/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdBasicData200,
  GetApiV1PersonIdBasicData401,
  GetApiV1PersonIdBasicData404,
  GetApiV1PersonIdBasicData500,
  GetApiV1PersonIdBasicDataPathParams,
  GetApiV1PersonIdBasicDataQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdBasicData.ts";
import { personBasicDataViewModelSchema } from "../personBasicDataViewModelSchema.ts";

export const getApiV1PersonIdBasicDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdBasicDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdBasicData200Schema = z.lazy(
  () => personBasicDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdBasicData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdBasicData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdBasicData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdBasicData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdBasicData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdBasicData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdBasicData500>;

export const getApiV1PersonIdBasicDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdBasicData200Schema,
) as unknown as ToZod<GetApiV1PersonIdBasicDataQueryResponse>;
